import { Injectable } from '@angular/core';
import { ComplexFormParent } from '../utils/complex-form-parent';

@Injectable({
  providedIn: 'root'
})
export class LfroOfficeService extends ComplexFormParent {

  override initializeForm() {
    super.initializeForm();
  }

  override initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Your Office':
          if (this.surveyService.surveyModel.getValue('LicName')) {
            let corpname = this.surveyService.surveyModel.getValue('LicName').substring(0, 30);
            this.surveyService.surveyModel.setValue('business_name', corpname);
            this.surveyService.surveyModel.setValue('office_name', corpname);
            this.surveyService.surveyModel.setValue('office_formal_name', this.surveyService.surveyModel.getValue('LicName'));
            this.surveyService.surveyModel.setValue('office_corporate_name', corpname);
            this.surveyService.surveyModel.getQuestionByName('business_name').readOnly = true;
          }
          this.surveyService.surveyModel.setValue('o_phone', this.surveyService.surveyModel.getValue('cellnumber'));
          this.surveyService.surveyModel.setValue('o_email', this.surveyService.surveyModel.getValue('emailaddress'));
          break;
      }
    });

  }

  override initializeOnCurrentPageChanging() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
    });

  }

  override initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
    });
  }

}
